import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "dropdown", "mergeButton", "aliasButton"];

  connect() {
    this.fixed = false;
    this.fetchPath = this.element.dataset.fetchPath;
  }

  async search() {
    if (this.fixed) {
      return;
    }
    const query = this.inputTarget.value.trim();
    let results = [];
    if (query.length >= 2) {
      const response = await fetch(
        `${this.fetchPath}?name=${encodeURIComponent(query)}`,
        {
          headers: {
            Accept: "application/json"
          }
        }
      );
      if (!response.ok) {
        console.error("Skill search failed");
        this.renderDropdown([]);
        return;
      }

      results = await response.json();
    }
    this.renderDropdown(results);
  }

  renderDropdown(skillNames) {
    const list = this.dropdownTarget.querySelector("ul");
    list.innerHTML = "";

    if (skillNames.length === 0 || this.inputTarget.value.trim() === "") {
      this.dropdownTarget.style.display = "none";
      return;
    }

    skillNames.forEach(skillName => {
      const li = document.createElement("li");
      const a = document.createElement("a");
      a.textContent = skillName;
      a.classList.add("dropdown-item");
      a.addEventListener("click", () => this.selectSkill(skillName));
      li.appendChild(a);
      list.appendChild(li);
    });

    this.dropdownTarget.style.display = "block";
  }

  clear() {
    this.inputTarget.value = "";
    this.inputTarget.readOnly = false;
    this.inputTarget.disabled = false;
    this.dropdownTarget.style.display = "none";
    this.fixed = false;

    // 以下関連フォームボタンへの操作
    // 本当は別controllerが望ましい
    const mergeForm = this.mergeButtonTarget.form;
    const mergeFormTargetInput = mergeForm.querySelector(
      'input[name="target"]'
    );
    this.mergeButtonTarget.dataset.confirm = "";
    if (mergeFormTargetInput) {
      mergeFormTargetInput.remove();
    }
    this.mergeButtonTarget.disabled = true;

    const aliasForm = this.aliasButtonTarget.form;
    const aliasFormTargetInput = aliasForm.querySelector(
      'input[name="target"]'
    );
    this.aliasButtonTarget.dataset.confirm = "";
    if (aliasFormTargetInput) {
      aliasFormTargetInput.remove();
    }
    this.aliasButtonTarget.disabled = true;
  }

  selectSkill(skillName) {
    this.inputTarget.value = skillName;
    this.inputTarget.readOnly = true;
    this.inputTarget.disabled = true;
    this.dropdownTarget.style.display = "none";
    this.fixed = true;

    // 以下関連フォームボタンへの操作
    // 本当は別controllerが望ましい
    const selectedSkillInput = document.createElement("input");
    selectedSkillInput.type = "hidden";
    selectedSkillInput.name = "target";
    selectedSkillInput.value = skillName;
    this.mergeButtonTarget.before(selectedSkillInput);
    this.mergeButtonTarget.dataset.confirm = this.mergeButtonTarget.dataset.confirmtext.replaceAll(
      "$target",
      skillName
    );
    this.mergeButtonTarget.disabled = false;

    this.aliasButtonTarget.before(selectedSkillInput);
    this.aliasButtonTarget.dataset.confirm = this.aliasButtonTarget.dataset.confirmtext.replaceAll(
      "$target",
      skillName
    );
    this.aliasButtonTarget.disabled = false;
  }
}
